import { Module } from '../Module';
import { SiteRoleOptionsResource } from '../resources/SiteRoleOptions';

export interface ISiteRoleFilter {
  (siteRole: string): string;
}

Module.instance().filter('siteRole', [
  '$translate',
  'SiteRoleOptionsResource',
  ($translate: ng.translate.ITranslateService, siteRoleOptionsResource: SiteRoleOptionsResource): ISiteRoleFilter => {
    return (siteRole: string) => {
      return !!siteRole ? $translate.instant(siteRoleOptionsResource.getSiteRoleLockey(siteRole)) : '';
    };
  }
]);
